import { setTags } from './actions';
import { TThunkAction } from '../../types/redux/thunk';
import { filterTagsByJsonQuery } from '../../utils/tags';

/**
 * Redux action, который удаляет добавленные теги, приводя их список к исходному состоянию
 */
export const resetTags = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const jsonQuery = state.jsonQuery;
  const tags = state.tags;

  const prevTags = filterTagsByJsonQuery(tags, jsonQuery);

  dispatch(setTags(prevTags));
};
